import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import ReactQuill from 'react-quill-new';
import 'react-quill/dist/quill.snow.css';

const EditPageModal = ({ show, handleClose, page, onSave }) => {
  const [message, setMessage] = useState('');
  const [bannerTitle, setBannerTitle] = useState('');
  const [title, setTitle] = useState('');
  const [isEnabled, setIsEnabled] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (page) {
      setMessage(page.message || '');
      setBannerTitle(page.banner_title || '');
      setTitle(page.title || '');
      setIsEnabled(!!page.is_enabled);
      setError('');
    }
  }, [page]);

  const handleSubmit = () => {
    if (!message || message.replace(/<[^>]*>?/gm, '').trim() === '') {
      setError('Message is required');
      return;
    }
    console.log(isEnabled)
    const updatedPage = {
      ...page,
      message,
      banner_title: bannerTitle,
      title,
      is_enabled: isEnabled ? 1 : 0,
    };

    onSave(updatedPage);
    setError('');
  };

  const closeAndReset = () => {
    setMessage('');
    setBannerTitle('');
    setTitle('');
    setIsEnabled(false);
    setError('');
    handleClose();
  };

  return (
    <Modal show={show} onHide={closeAndReset} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Page: {page?.page_name}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-4">
            {page?.page_name === 'Appointment Confirmation' && (
            <>
          <label style={{ textAlign: 'left', display: 'block', fontWeight: '500' }}>Banner Title</label>
          <input
            type="text"
            className="form-control px-2 mb-3"
            value={bannerTitle}
            onChange={(e) => setBannerTitle(e.target.value)}
          />
   
          <label style={{ textAlign: 'left', display: 'block', fontWeight: '500' }}>Title</label>
          <input
            type="text"
            className="form-control px-2 mb-3"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
 </>
            )}
          <Form.Label style={{ textAlign: 'left', display: 'block', fontWeight: '500' }}>
            Message <span className="text-danger">*</span>
          </Form.Label>
          <div className={`quill-wrapper ${error ? 'is-invalid' : ''}`}>
            <ReactQuill
              theme="snow"
              value={message}
              onChange={setMessage}
              style={{ height: '250px' }}
            />
          </div>
          {error && <div className="invalid-feedback d-block mt-1">{error}</div>}
        </Form.Group>

                {(
            page?.page_name === 'Appointment Booking' ||
            page?.page_name === 'Payment Button' ||
            page?.page_name === 'Pay Later Button'
            ) && (
          <Form.Group className="mb-2">
            <Form.Check
              type="checkbox"
              id="enable-page-checkbox"
              checked={isEnabled}
              onChange={(e) => setIsEnabled(e.target.checked)}
              label={<span className="fw-medium">Enable Page</span>}
              className="d-flex align-items-center"
              style={{ fontSize: '1rem', cursor: 'pointer' }}
            />
          </Form.Group>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={closeAndReset}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditPageModal;
